module.exports = __webpack_public_path__ + "img/import.fce566eb.webp";